export default axios => ({
  getList() {
    return axios.get('/deviation/field/list');
  },
  add(payload) {
    return axios.post('/deviation/add', payload)
  },
  saveZone(payload) {
    return axios.post('/deviation/markup/add', payload)

  },
  updateZone(payload) {
    return axios.patch(`/deviation/markup/${payload.pointId}`, payload)
  },
  rmZone(id) {
    return axios.delete(`/deviation/markup/${id}`)
  }
})
